module.exports = __webpack_public_path__ + "static/media/officeImg6.07a25813.jpg";